// extracted by mini-css-extract-plugin
export default {"draggableview":"ad7215d320684bae03cc"};